import { Box, Heading, Text, VStack, UnorderedList, ListItem, Alert, AlertIcon } from '@chakra-ui/react';
import { useEffect } from 'react';

export default function RefundPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box>
      <VStack p={[5, 10, 20]} spacing={8} align="start" maxW="1200px" mx="auto">
        <Heading color="#0C727E" size="2xl">Refund & Cancellation Policy</Heading>
        
        <Text fontSize="lg">
          Our focus is on complete customer satisfaction. In the event that you are displeased with the services provided or we are unable to provide the service, we will refund back the money, provided the reasons are genuine.
        </Text>

        <Alert status="info" borderRadius="xl">
          <AlertIcon />
          No refund shall be admissible after the test has been completed.
        </Alert>

        <VStack align="start" spacing={4} width="100%">
          <Heading size="md" color="teal.700">Cancellation Policy</Heading>
          <UnorderedList spacing={3} pl={5}>
            <ListItem>
              <strong>Lab Visit:</strong> Customers are free to cancel the booking before the start of lab tests. A full refund shall be admissible if payment was made to Dilate Labs directly.
            </ListItem>
            <ListItem>
              <strong>Home Visit:</strong> Customers can cancel the tests prior to the start of the visit for a full refund.
            </ListItem>
            <ListItem>
              <strong>On-site Cancellation:</strong> If a customer cancels after the technician has arrived at the site, Rs 200/- shall be deducted as visit charges.
            </ListItem>
            <ListItem>
              <strong>Partial Tests:</strong> In cases where only partial tests from the booking have been completed, a refund shall be admissible for the remaining tests.
            </ListItem>
          </UnorderedList>
        </VStack>

        <VStack align="start" spacing={4} width="100%">
          <Heading size="md" color="teal.700">Refund Process</Heading>
          <Text>
            Refunds will be issued to the original credit card or bank account used at the time of purchase. The refund shall be processed within <strong>7-15 working days</strong> wherever applicable.
          </Text>
        </VStack>

        <VStack align="start" spacing={4} width="100%">
          <Heading size="md" color="teal.700">Contact for Grievances</Heading>
          <Text>
            For any cancellations or refund queries, please contact us at:
            <br />
            <strong>Email:</strong> info@dilatelabs.com
          </Text>
        </VStack>
      </VStack>
    </Box>
  );
}
